import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'AS', pure: true, standalone: true})
export class AsCastPipe implements PipeTransform {
	transform<T>(input: unknown, _baseItem: T | undefined): T {
		return input as unknown as T;
	}
}
